import { IconPropsType } from '..';

export const FacebookIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_191_27210)">
      <circle
        cx="20.6666"
        cy="20"
        r="20"
        fill="#1D2F5A"
      />
      <path
        d="M22.7768 32V21.4996H26.2781L26.9447 17.1562H22.778V14.3372C22.778 13.1492 23.3599 11.9901 25.2267 11.9901H27.1214V8.294C27.1214 8.294 25.4022 8 23.758 8C20.3244 8 18.0813 10.0798 18.0813 13.846V17.1562H14.2666V21.4996H18.0813V32H22.7768Z"
        fill="#255FFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_191_27210">
        <rect
          width="40"
          height="40"
          fill="white"
          transform="translate(0.666626)"
        />
      </clipPath>
    </defs>
  </svg>
);
